import React from "react";
import {Typography} from "@mui/material";
import {PlatformTable} from "../PlatformTable";
import {withAppContext} from "../../util/withAppContext";
import withNavigate from "../../util/useNavigate";
import withBreakpoint from "../../util/withBreakpoint";
import {Blue3, Grey17} from "../../theme/styles";
import {statusPill} from "../../util/statusPill";
import ChangeOrderFormApplet from "../../eoec/applet/impl/Foundation/ChangeOrderFormApplet";

/**
 * The change order list grid.
 *
 * THE IDENTIFIER IS THE LINK, not the title. "CO-00014" is what people quote and what they scan a
 * list for; making the title the link would put the click target on the column whose width varies
 * most and whose text is the one thing that is not an identifier.
 */
class ChangeOrderTable extends PlatformTable {

    getCellRenderer(name) {
        if (name === "Change Order Id Cell") {
            return this.renderIdCell;
        }
        if (name === "Change Order State Cell") {
            return this.renderStateCell;
        }
        return super.getCellRenderer(name);
    }

    renderIdCell = (___, params, __, _) => {
        // USID IS NOT A COLUMN, and a row only carries its placed columns -- so reading it off
        // params.row yields undefined and every identifier renders as plain text with no link.
        // See PlatformTable.readAttribute.
        const usid = this.readAttribute(params, "USID");
        const identifier = this.readAttribute(params, "ChangeOrderID");

        const cell = (content) => (
            <div style={{display: "flex", alignItems: "center", height: "100%", minWidth: 0}}>
                {content}
            </div>
        );

        if (!usid) {
            return cell(<Typography style={{fontSize: 14, color: Grey17}}>{identifier || "—"}</Typography>);
        }

        return cell(
            <Typography onClick={() => this.props.navigate(`/change-orders/${usid}`)}
                        style={{fontSize: 14, fontWeight: 500, color: Blue3, cursor: "pointer"}}>
                {identifier || "—"}
            </Typography>
        );
    };

    /**
     * The state as a pill, from the SAME palette every other lifecycle uses.
     *
     * A change order's states are not a revision's, but they mean the same kinds of thing and a
     * reader moves between the two screens: DRAFT reads as work in progress either way, APPROVED as
     * settled, VOIDED as out of service. Inventing a second colour scheme here would make the same
     * word mean two things in one product.
     */
    renderStateCell = (___, params, __, _) => {
        const state = this.readAttribute(params, "State");
        return (
            <div style={{display: "flex", alignItems: "center", height: "100%"}}>
                {statusPill(state)}
            </div>
        );
    };

    handleMenuClick(identifier) {
        if (identifier === "Raise Change Order") {
            this.setState({renderTarget: "Raise Change Order"});
            return;
        }
        super.handleMenuClick(identifier);
    }

    renderExtension() {
        if (this.state.renderTarget === "Raise Change Order") {
            return <ChangeOrderFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()}
                                          defaultAction="New"/>;
        }
        return super.renderExtension();
    }
}

export default withNavigate(withAppContext(withBreakpoint(ChangeOrderTable)));
